import React from "react";
import { useNavigate } from "react-router-dom"; // Import useNavigate
import logo from "../Utils/logo.png";

const Footer = () => {
  const navigate = useNavigate(); // Initialize useNavigate

  // Inline styles (optimized for full-width and better layout)
  const styles = {
    footer: {
      width: "100vw", // Full width of the viewport
      background: "linear-gradient(135deg, #003366, #5CE1E6)", // Theme background
      color: "#FFFFFF", // White text
      textAlign: "center",
      padding: "30px 0",
      position: "relative",
    },
    footerLink: {
      color: "#fff",
      textDecoration: "none",
      margin: "0 15px",
      cursor: "pointer",
      fontSize: "16px",
      transition: "color 0.3s ease-in-out",
    },
    footerLinkHover: {
      textDecoration: "underline",
      color: "#FFD700", // Gold on hover for emphasis
    },
    logo: {
      width: "80%",
      maxWidth: "150px",
      cursor: "pointer", // Ensure logo is clickable
    },
    disclaimer: {
      fontSize: "14px",
      color: "#E0E0E0",
      marginTop: "10px",
    },
    bottomText: {
      fontSize: "14px",
      marginTop: "20px",
    },
  };

  const handleLinkClick = (path) => {
    navigate(path);
  };

  return (
    <footer style={styles.footer}>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <ul className="list-inline">
              <li className="list-inline-item">
                <img 
                  src={logo} 
                  alt="Logo" 
                  style={styles.logo} 
                  onClick={() => handleLinkClick("/home")} // Navigate to home on click
                />
              </li>
              <li className="list-inline-item">
                <span
                  style={styles.footerLink}
                  onClick={() => handleLinkClick("/")}
                >
                  Home
                </span>
              </li>
              <li className="list-inline-item">
                <span
                  style={styles.footerLink}
                  onClick={() => handleLinkClick("/about")}
                >
                  About
                </span>
              </li>
              <li className="list-inline-item">
                <span
                  style={styles.footerLink}
                  onClick={() => handleLinkClick("/services")}
                >
                  Services
                </span>
              </li>
              <li className="list-inline-item">
                <span
                  style={styles.footerLink}
                  onClick={() => handleLinkClick("/articles")}
                >
                  Articles
                </span>
              </li>
              <li className="list-inline-item">
                <span
                  style={styles.footerLink}
                  onClick={() => handleLinkClick("/contact")}
                >
                  Contact Us
                </span>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://www.facebook.com/profile.php?id=61570629539525"
                  style={styles.footerLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://www.instagram.com/p/DDpbLpayJ-V/?igsh=ZG1mMTl5Z2xlZmRv"
                  style={styles.footerLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </li>
              <li className="list-inline-item">
                <a
                  href="https://www.youtube.com/@ismartechtelugu"
                  style={styles.footerLink}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  YouTube
                </a>
              </li>
            </ul>
          </div>
        </div>
        {/* Disclaimer Section */}
        <div className="row">
          <div className="col-md-12 text-center p-3">
            <p style={styles.disclaimer}>
              The risks of loss from investing in stocks and f&o can be
              substantial. 90% of retail client accounts lose money when trading
              stocks and f&o. Consider whether you understand how this product
              works before investing.
            </p>

            <p style={styles.bottomText}>
              &copy; <span id="displayYear"></span> All Rights Reserved By{" "}
              <a
                href="https://simbesi.com"
                style={{ color: "#FFD700", textDecoration: "none" }}
              >
                Simbesi Technosoft Pvt Ltd
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
